import { Theme } from 'types/CommonTypes';
import defaultTheme from 'styles/theme';

const themeVariant = {
    [Theme.DEFAULT]: defaultTheme,
};

export default themeVariant;
